export default [
  { title: "C# SDK", icon: "", link: "/docs/c-sdk" },
  { title: "Setup and configuration", icon: "", link: "/docs/c-sdk-setup-configuration" },
  { title: "Authentication", icon: "", link: "/docs/c-sdk-authentication" },
  { title: "Accessing the object model", icon: "", link: "/docs/c-sdk-access-modal" },
  { title: "Calling methods and handling errors", icon: "", link: "/docs/c-sdk-calling-methods" },
  { title: "Reference", icon: "", link: "/referencec" },
];
